import { Atom } from "@thi.ng/atom";

export const reset = <T>(state: Atom<T>, update: Partial<T>) => {
  state.reset({ ...state.deref(), ...update });
};
